export default function ResultsHeader({ searching, results, label }) {
  return (
    <div
      className="mb-10 flex items-baseline justify-between gap-4 flex-wrap"
      data-testid="results-header"
    >
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-white/40 mb-2">Risultati</div>
        <h2 className="font-display text-3xl sm:text-4xl" data-testid="results-title">
          {searching ? "Ricerca in corso…" : label || "Lotti trovati"}
        </h2>
      </div>
      {!searching && results && (
        <div className="text-sm text-white/50" data-testid="results-meta">
          <span className="text-gold font-medium" data-testid="results-count">
            {results.filtered_count}
          </span>
          {" / "}
          {results.returned} lotti dopo i filtri
          {results.total ? (
            <span className="text-white/30">
              {" · "}
              {results.total.toLocaleString("it-IT")} totali su Catawiki
            </span>
          ) : null}
        </div>
      )}
    </div>
  );
}
